var map = {
	"./fb.svg": "404e",
	"./git.svg": "c689",
	"./instagram.svg": "0eca",
	"./kh.svg": "7253",
	"./linkedin.svg": "8e98",
	"./twitter.svg": "bebf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0923";